module.exports = __webpack_public_path__ + "img/agentstudio-hero.7dd7d8fd.jpg";